// File: clientapp/src/pages/TrainingSetList.jsx
import React, { useEffect, useState } from 'react';
import { Container, Button, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import SchoolIcon from '@mui/icons-material/School';
import CreateTrainingSetDialog from '../components/CreateTrainingSetDialog';
import TrainModelDialog from '../components/TrainModelDialog';
import PageLayout from '../components/PageLayout';
import './TrainingSetList.css';

export default function TrainingSetList() {
    const [trainingSets, setTrainingSets] = useState([]);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [trainDialogOpen, setTrainDialogOpen] = useState(false);
    const [selectedTrainingSet, setSelectedTrainingSet] = useState(null);

    useEffect(() => {
        async function fetchTrainingSets() {
            try {
                const response = await fetch('/api/TrainingSet', {
                    method: 'GET',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                });
                if (response.ok) {
                    const data = await response.json();
                    setTrainingSets(data);
                }
            } catch (error) {
                console.error('Error fetching training sets:', error);
            }
        }
        fetchTrainingSets();
    }, []);

    const handleDialogOpen = () => {
        setDialogOpen(true);
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleCreateTrainingSet = async (newTrainingSet) => {
        try {
            const response = await fetch('/api/TrainingSet/create', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(newTrainingSet),
            });
            if (response.ok) {
                const created = await response.json();
                setTrainingSets((prev) => [...prev, created]);
                setDialogOpen(false);
            } else {
                alert("Error creating training set");
            }
        } catch (error) {
            console.error("Error creating training set:", error);
        }
    };

    const handleTrainModelClick = (trainingSet) => {
        setSelectedTrainingSet(trainingSet);
        setTrainDialogOpen(true);
    };

    const handleTrainDialogClose = () => {
        setTrainDialogOpen(false);
    };

    const handleTrainModelSubmit = async (payload) => {
        try {
            const response = await fetch('/api/TrainingSet/trainmodel', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                console.error("Error scheduling model training");
            }
        } catch (error) {
            console.error("Error calling trainmodel endpoint:", error);
        }
        setTrainDialogOpen(false);
    };

    return (
        <Container className="training-set-container">
            <PageLayout
                breadcrumb={[
                    { label: 'Home', to: '/' },
                    { label: 'Training Sets' }
                ]}
                showBack={false}
                showClose={false}
                icon={<SchoolIcon sx={{ fontSize: 48 }} />}
                title="Training Sets"
                subTitle="Manage and create training sets"
            >
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDialogOpen}
                    sx={{ mb: 2 }}
                >
                    Create New Training Set
                </Button>
                <CreateTrainingSetDialog
                    open={dialogOpen}
                    onClose={handleDialogClose}
                    onCreate={handleCreateTrainingSet}
                />
                <Paper className="training-set-table-paper">
                    <Table className="training-set-table">
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Domain</TableCell>
                                <TableCell>Created At</TableCell>
                                <TableCell>Manage</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {trainingSets.map((set) => (
                                <TableRow key={set.trainingSetId}>
                                    <TableCell>{set.trainingSetId}</TableCell>
                                    <TableCell>{set.name}</TableCell>
                                    <TableCell>{set.documentDomain?.domainName}</TableCell>
                                    <TableCell>{new Date(set.createdAt).toLocaleString()}</TableCell>
                                    <TableCell>
                                        <Button variant="outlined" component={Link} to={`/training/${set.trainingSetId}`}>
                                            Manage
                                        </Button>
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() => handleTrainModelClick(set)}
                                        >
                                            Train Model
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
                <TrainModelDialog
                    open={trainDialogOpen}
                    onClose={handleTrainDialogClose}
                    onSubmit={handleTrainModelSubmit}
                    trainingSet={selectedTrainingSet}
                />
            </PageLayout>
        </Container>
    );
}
